var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDugood5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 179,
    viewBox: "0 0 225 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.218 178.398C39.3536 178.398 0 142.634 0 89.7637C0 36.8933 39.3536 0.937256 112.218 0.937256C185.083 0.937256 224.666 36.9376 224.666 89.7858C224.666 142.634 185.083 178.398 112.218 178.398ZM112.218 132.293C132.235 132.293 143.477 121.495 143.477 89.7858C143.477 57.6263 132.235 47.0567 112.218 47.0567C92.2019 47.0567 80.9601 57.6263 80.9601 89.7858C80.9601 121.495 92.2019 132.293 112.218 132.293Z",
    fill: "url(#paint0_linear_2826_77658)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2826_77658",
    x1: 221.453,
    y1: -401.928,
    x2: 217.014,
    y2: 78.7435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugood5);
export default __webpack_public_path__ + "static/media/dugood5.efae3303ff93804af9b1910226b8591d.svg";
export { ForwardRef as ReactComponent };